<script setup lang="ts">
import useUserStore from '~~/app/store/user'

const emits = defineEmits(['layoutLoaded'])
const config = useRuntimeConfig()

const { APPLICATION_URL, NODE_ENV } = config.public
const { href } = useRequestURL()

const locales = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt']

useSeoMeta({
    ogType: 'website',
    ogLocale: useLanguage(),
    ogLocaleAlternate: locales,
    ogUrl: href,
    robots: { noindex: NODE_ENV !== 'production' }
})

onBeforeMount(() => {
    useUserStore().fetchChargemapUsersCount()
    emits('layoutLoaded')
})

const head = useLocaleHead()
</script>

<template>
    <Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">
        <Head>
            <Link
                rel="apple-touch-icon"
                type="image/png"
                sizes="180x180"
                :href="`${APPLICATION_URL}/meta/apple-touch-icon.png`"
            />
            <Link
                rel="mask-icon"
                color="#5bbad5"
                :href="`${APPLICATION_URL}/meta/safari-pinned-tab.svg`"
            />
            <Link rel="canonical" crossorigin="use-credentials" :href />
            <Link
                rel="manifest"
                crossorigin="use-credentials"
                :href="`${APPLICATION_URL}/meta/site.webmanifest`"
            />
            <template v-for="link in head.link" :key="link.hid">
                <Link
                    :id="link.hid"
                    :rel="link.rel"
                    :href="link.href"
                    :hreflang="link.hreflang"
                />
            </template>
            <Link rel="icon" :href="`${APPLICATION_URL}/favicon.svg`" />
            <template v-for="meta in head.meta" :key="meta.hid">
                <Meta
                    :id="meta.hid"
                    :property="meta.property"
                    :content="meta.content"
                />
            </template>
            <Meta name="theme-color" content="#ffffff" />
        </Head>
        <Body>
            <slot />
        </Body>
    </Html>
</template>
